import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingComponentComponent } from '@shared/loading-component/loading-component.component';
import {RouterModule} from '@angular/router';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
  ],
  exports: [
    LoadingComponentComponent
  ],
  declarations: [
    LoadingComponentComponent
  ]
  
})
export class SharedModule { }
